import React, { useState } from "react";
import { Card, List, message, Modal, Space, Tooltip } from "antd";
import { MailFilled } from "@ant-design/icons";
import { Folder } from "../../redux/interfaces/folder.types.ts";
import { useAppDispatch } from "../../redux/hooks.ts";
import { sendFolderStatusEmail } from "../../redux/actions/folderActions.tsx";
import { Typography } from "../material-old";
import { extractErrorMessage } from "../../utils/extractErrorMessage.ts";

interface Props {
  folder: Folder;
}

export const NotifyNow: React.FC<Props> = ({ folder }) => {
  const tenant = folder.metadata?.tenant;
  const advisor = folder.metadata?.advisor;
  const guarantor = folder.metadata?.guarantor;
  const landlord = folder.metadata?.landlord;

  const notifyUsers = [
    { email: tenant?.email, role: "Inquilino" },
    { email: advisor?.email, role: "Asesor" },
    { email: guarantor?.email, role: "Fiador u Obligado Solidario" },
    { email: landlord?.email, role: "Propietario" },
  ].filter((user) => user.email);

  const dispatch = useAppDispatch();
  const [messageApi, contextHolder] = message.useMessage();
  const [isSendingEmail, setIsSendingEmail] = useState<boolean>(false);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);

  const onClosedModal = () => {
    setIsModalVisible(false);
  };

  const onOpenModal = () => {
    setIsModalVisible(true);
  };

  const handleNotifyByEmail = async () => {
    try {
      setIsSendingEmail(true);
      await dispatch(sendFolderStatusEmail(folder.id)).unwrap();
    } catch (error: any) {
      messageApi.error(extractErrorMessage(error, "No se pudo enviar la notificación."));
    } finally {
      setIsSendingEmail(false);
      setIsModalVisible(false);
    }
  };

  return (
    <div>
      {contextHolder}
      <Modal
        title="Enviar estatus"
        open={isModalVisible}
        onOk={handleNotifyByEmail}
        onCancel={onClosedModal}
        loading={isSendingEmail}
      >
        <Card>
          <Space className="w-full flex flex-col">
            <div className="w-full justify-start text-left overflow-hidden !border-none mb-4">
              Esta acción enviará inmediatamente un correo notificando sobre el
              estatus del expediente.
            </div>
            <div className="w-full">
              <List
                className="w-full"
                header={
                  <Typography
                    variant="h6"
                    color="blue-gray"
                    className="text-center"
                  >
                    Destinatarios
                  </Typography>
                }
                dataSource={notifyUsers}
                renderItem={(user) => (
                  <List.Item>
                    <div className="w-full flex justify-between space-x-2">
                      <span>{user.email}</span>
                      <span>
                        <b>({user.role})</b>
                      </span>
                    </div>
                  </List.Item>
                )}
                bordered
              />
            </div>
          </Space>
        </Card>
      </Modal>
      <Tooltip title="Notificar ahora" className="cursor-pointer">
        <MailFilled
          style={{ fontSize: "18px" }}
          className="text-gray-600 hover:text-blue-400"
          onClick={onOpenModal}
        />
      </Tooltip>
    </div>
  );
};
